// extracted by mini-css-extract-plugin
module.exports = {"section":"styles_section__21ePC","items":"styles_items__2jj8O"};